// src/AlwaysLinks.tsx
import { MoreHoriz as MoreHorizIcon } from "@mui/icons-material";
import { FlexRow } from "@xylabs/react-flexbox";

// src/Link.tsx
import { assertEx } from "@xylabs/assert";
import { LinkEx } from "@xylabs/react-link";
import { jsx } from "react/jsx-runtime";
var convertToBetaIfNeeded = (url, currentUrl = new URL(document.location.href)) => {
  const urlObj = typeof url === "string" ? new URL(url) : url;
  const currentUrlObj = typeof currentUrl === "string" ? new URL(currentUrl) : currentUrl;
  const currentHostnameParts = currentUrlObj.hostname.split(".");
  const beta = currentHostnameParts.shift() === "beta";
  if (beta) {
    const currentHostnameWithoutBeta = currentHostnameParts.join(".");
    if (currentHostnameWithoutBeta === urlObj.hostname) {
      urlObj.hostname = currentUrlObj.hostname;
    }
  }
  return urlObj;
};
var FooterLink = ({
  target,
  to,
  toOptions,
  href,
  margin = 0.5,
  variant = "body2",
  ...props
}) => {
  if (href) {
    const url = new URL(assertEx(href, () => "href not set"));
    assertEx(url.hostname, () => "Hostname is required in href");
    const convertedUrl = convertToBetaIfNeeded(url);
    if (document.location.hostname === convertedUrl.hostname) {
      const to2 = url.search.length > 0 ? `${convertedUrl.pathname}${convertedUrl.search}` : url.pathname;
      return /* @__PURE__ */ jsx(LinkEx, { margin, to: to2, toOptions, target, variant, ...props });
    } else {
      return /* @__PURE__ */ jsx(LinkEx, { margin, href, target: target ?? "_blank", variant, ...props });
    }
  } else {
    return /* @__PURE__ */ jsx(LinkEx, { margin, to, toOptions, target, variant, ...props });
  }
};

// src/AlwaysLinks.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var FooterAlwaysLinks = ({
  style,
  footerLinks: footerLinks2,
  onMore,
  ...props
}) => /* @__PURE__ */ jsxs(
  FlexRow,
  {
    flexWrap: "wrap",
    textTransform: "uppercase",
    style: { opacity: 0.6, ...style },
    ...props,
    children: [
      footerLinks2?.map((footerLink, index) => /* @__PURE__ */ jsx2(FooterLink, { noWrap: true, paddingX: 1, margin: 0, ...footerLink, children: /* @__PURE__ */ jsx2("small", { children: footerLink.title }) }, index)),
      onMore ? /* @__PURE__ */ jsx2(FlexRow, { style: { cursor: "pointer" }, paddingX: 0.5, onClick: onMore, children: /* @__PURE__ */ jsx2(MoreHorizIcon, { color: "primary", fontSize: "small" }) }) : null
    ]
  }
);

// src/Footer.tsx
import { Container } from "@mui/material";
import { FlexCol, FlexRow as FlexRow2 } from "@xylabs/react-flexbox";
import { useIsDark } from "@xylabs/react-theme";
import { useState } from "react";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var Footer = ({
  alwaysFooterLinksProps,
  children,
  container,
  dynamicHeight = false,
  ...props
}) => {
  const [more, setMore] = useState(false);
  const onMore = () => {
    setMore(!more);
  };
  const darkMode = useIsDark();
  console.log("darkMode", darkMode);
  return /* @__PURE__ */ jsxs2(
    FlexCol,
    {
      alignItems: "stretch",
      onMouseLeave: () => {
        setMore(false);
      },
      ...props,
      children: [
        more && dynamicHeight ? /* @__PURE__ */ jsx3(FlexCol, { alignItems: "stretch", children: /* @__PURE__ */ jsx3(FlexRow2, { paper: true, bottom: -1, position: "absolute", width: "100%", children: container && container !== "none" ? /* @__PURE__ */ jsx3(Container, { children }) : children }) }) : null,
        dynamicHeight ? null : /* @__PURE__ */ jsx3(FlexCol, { alignItems: "stretch", children: container && container !== "none" ? /* @__PURE__ */ jsx3(Container, { children }) : children }),
        /* @__PURE__ */ jsx3(FlexRow2, { children: container && container !== "none" ? /* @__PURE__ */ jsx3(Container, { children: /* @__PURE__ */ jsx3(FooterAlwaysLinks, { ...alwaysFooterLinksProps, onMore: dynamicHeight ? onMore : void 0 }) }) : /* @__PURE__ */ jsx3(FooterAlwaysLinks, { ...alwaysFooterLinksProps, onMore: dynamicHeight ? onMore : void 0 }) })
      ]
    }
  );
};

// src/lib/copyrightLinkTitle.ts
var copyrightLinkTitle = (entity) => {
  return `Copyright \xA9 ${(/* @__PURE__ */ new Date()).getFullYear()} ${entity}`;
};

// src/Links.tsx
import { Typography } from "@mui/material";
import { FlexCol as FlexCol2 } from "@xylabs/react-flexbox";
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var FooterLinks = ({
  children,
  title,
  ...props
}) => {
  return /* @__PURE__ */ jsxs3(FlexCol2, { margin: 1, justifyContent: "flex-start", title, ...props, children: [
    /* @__PURE__ */ jsx4(Typography, { margin: 0.5, variant: "h6", noWrap: true, children: title }),
    children
  ] });
};

// src/Xyo/AlwaysLinks.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var XyoFooterAlwaysLinks = (props) => /* @__PURE__ */ jsx5(
  FooterAlwaysLinks,
  {
    footerLinks: [
      {
        href: "https://xylabs.com/",
        title: copyrightLinkTitle("XY Labs, Inc.")
      },
      {
        href: "https://xyo.network/",
        title: "XYO Foundation"
      },
      {
        href: "https://xylabs.com/privacy/",
        title: "Privacy"
      },
      {
        href: "https://xylabs.com/terms/",
        title: "Terms"
      },
      {
        href: "https://xylabs.com/jobs",
        title: "Careers"
      }
    ],
    ...props
  }
);

// src/Xyo/DeveloperLinks.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var DeveloperLinks = (props) => /* @__PURE__ */ jsxs4(FooterLinks, { title: "Developer", ...props, children: [
  /* @__PURE__ */ jsx6(FooterLink, { href: "https://xyo.network/developer", children: "Overview" }),
  /* @__PURE__ */ jsx6(FooterLink, { href: "https://xyo.network/developer/get-started", children: "Get Started" }),
  /* @__PURE__ */ jsx6(FooterLink, { href: "https://xyo.network/developer", children: "SDKs" }),
  /* @__PURE__ */ jsx6(FooterLink, { href: "https://github.com/xyoraclenetwork", children: "Open Source Github" }),
  /* @__PURE__ */ jsx6(FooterLink, { href: "https://xyo.network/docs/sdk/js", children: "Documentation" })
] });

// src/Xyo/Footer.tsx
import { Grid } from "@mui/material";

// src/Xyo/MoreLinks.tsx
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var MoreLinks = (props) => /* @__PURE__ */ jsxs5(FooterLinks, { title: "More", ...props, children: [
  /* @__PURE__ */ jsx7(FooterLink, { href: "https://xyo.network/partners", children: "Partners" }),
  /* @__PURE__ */ jsx7(FooterLink, { href: "https://xyo.network/fhr", children: "FHR" }),
  /* @__PURE__ */ jsx7(FooterLink, { href: "https://xyo.network/brand", children: "Brand" })
] });

// src/Xyo/NetworkLinks.tsx
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var NetworkLinks = (props) => /* @__PURE__ */ jsxs6(FooterLinks, { title: "Network", ...props, children: [
  /* @__PURE__ */ jsx8(FooterLink, { href: "https://xyo.network/network", children: "Overview" }),
  /* @__PURE__ */ jsx8(FooterLink, { href: "https://xyo.network/network/bound-witness", children: "Bound Witness" }),
  /* @__PURE__ */ jsx8(FooterLink, { href: "https://xyo.network/network/proof-of-origin", children: "Proof Of Origin" }),
  /* @__PURE__ */ jsx8(FooterLink, { href: "https://xyo.network/papers", children: "White Paper" })
] });

// src/Xyo/SocialLinks.tsx
import {
  Facebook,
  Instagram,
  LinkedIn,
  Reddit,
  Telegram,
  Twitter,
  YouTube
} from "@mui/icons-material";
import { FlexRow as FlexRow3 } from "@xylabs/react-flexbox";
import { FaDiscord } from "react-icons/fa";
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var SocialLinks = (props) => {
  return /* @__PURE__ */ jsx9(FooterLinks, { title: "XYO Socials", ...props, children: /* @__PURE__ */ jsxs7(FlexRow3, { flexWrap: "wrap", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsx9(FooterLink, { href: "https://business.facebook.com/OfficialXYO/", children: /* @__PURE__ */ jsx9(Facebook, {}) }),
    /* @__PURE__ */ jsx9(FooterLink, { href: "https://twitter.com/OfficialXYO", children: /* @__PURE__ */ jsx9(Twitter, {}) }),
    /* @__PURE__ */ jsx9(FooterLink, { href: "https://www.instagram.com/officialxyo/", children: /* @__PURE__ */ jsx9(Instagram, {}) }),
    /* @__PURE__ */ jsx9(FooterLink, { href: "https://t.me/xyonetwork", children: /* @__PURE__ */ jsx9(Telegram, {}) }),
    /* @__PURE__ */ jsx9(FooterLink, { href: "https://www.reddit.com/r/XYONetwork/", children: /* @__PURE__ */ jsx9(Reddit, {}) }),
    /* @__PURE__ */ jsx9(FooterLink, { href: "https://www.youtube.com/channel/UCyZDqb9pgntVHJVt1pxXtsw", children: /* @__PURE__ */ jsx9(YouTube, {}) }),
    /* @__PURE__ */ jsx9(FooterLink, { href: "https://www.linkedin.com/company/officialxyo/", children: /* @__PURE__ */ jsx9(LinkedIn, {}) }),
    /* @__PURE__ */ jsx9(FooterLink, { href: "https://discord.gg/officialxyo", children: /* @__PURE__ */ jsx9(FaDiscord, {}) })
  ] }) });
};

// src/Xyo/SupportLinks.tsx
import { jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var SupportLinks = (props) => /* @__PURE__ */ jsxs8(FooterLinks, { title: "Support", ...props, children: [
  /* @__PURE__ */ jsx10(FooterLink, { href: "https://support.xy.company/hc/en-us/categories/360001417734", children: "Help Center" }),
  /* @__PURE__ */ jsx10(FooterLink, { href: "https://support.xy.company/hc/en-us/requests/new", children: "Contact Support" })
] });

// src/Xyo/TokenLinks.tsx
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var TokenLinks = (props) => /* @__PURE__ */ jsxs9(FooterLinks, { title: "XYO Tokens", ...props, children: [
  /* @__PURE__ */ jsx11(FooterLink, { href: "https://xyo.network/token", children: "About" }),
  /* @__PURE__ */ jsx11(FooterLink, { href: "https://xyo.network/token/exchange", children: "Exchanges" }),
  /* @__PURE__ */ jsx11(FooterLink, { href: "https://xyo.network/token/price", children: "Prices" }),
  /* @__PURE__ */ jsx11(FooterLink, { href: "https://xyo.network/token/wallet", children: "Wallets" }),
  /* @__PURE__ */ jsx11(FooterLink, { href: "https://etherscan.io/address/0x55296f69f40ea6d20e478533c15a6b08b654e758", children: "Contract" })
] });

// src/Xyo/Footer.tsx
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var footerLinks = [
  {
    href: "https://xylabs.com/",
    title: copyrightLinkTitle("XY Labs, Inc.")
  },
  {
    href: "https://xyo.network/",
    title: "XYO Foundation"
  },
  {
    href: "https://xylabs.com/privacy/",
    title: "Privacy"
  },
  {
    href: "https://xylabs.com/terms/",
    title: "Terms"
  },
  {
    href: "https://xylabs.com/jobs",
    title: "Careers"
  }
];
var XyoFooter = ({
  alwaysFooterLinksProps,
  ...props
}) => {
  return /* @__PURE__ */ jsx12(Footer, { alwaysFooterLinksProps: alwaysFooterLinksProps ?? { footerLinks }, ...props, children: /* @__PURE__ */ jsxs10(Grid, { container: true, children: [
    /* @__PURE__ */ jsx12(Grid, { size: { xs: 12, md: 2 }, children: /* @__PURE__ */ jsx12(SocialLinks, { alignItems: "flex-start" }) }),
    /* @__PURE__ */ jsx12(Grid, { size: { xs: 6, md: 2 }, children: /* @__PURE__ */ jsx12(NetworkLinks, { alignItems: "flex-start" }) }),
    /* @__PURE__ */ jsx12(Grid, { size: { xs: 6, md: 2 }, children: /* @__PURE__ */ jsx12(TokenLinks, { alignItems: "flex-start" }) }),
    /* @__PURE__ */ jsx12(Grid, { size: { xs: 6, md: 2 }, children: /* @__PURE__ */ jsx12(DeveloperLinks, { alignItems: "flex-start" }) }),
    /* @__PURE__ */ jsx12(Grid, { size: { xs: 6, md: 2 }, children: /* @__PURE__ */ jsx12(MoreLinks, { alignItems: "flex-start" }) }),
    /* @__PURE__ */ jsx12(Grid, { size: { xs: 6, md: 2 }, children: /* @__PURE__ */ jsx12(SupportLinks, { alignItems: "flex-start" }) })
  ] }) });
};
export {
  FooterAlwaysLinks as Copyright,
  DeveloperLinks,
  Footer,
  FooterAlwaysLinks,
  FooterLink,
  FooterLinks,
  MoreLinks,
  NetworkLinks,
  SocialLinks,
  SupportLinks,
  TokenLinks,
  XyoFooter,
  XyoFooterAlwaysLinks,
  copyrightLinkTitle
};
//# sourceMappingURL=index.mjs.map